
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { getVariablePreviewValue } from "@/oxygen/variables/lib/utils";
import { Variable } from "@/oxygen/variables/lib/types";
import { globalStore } from "@/store/store";
import VariableRepeaterItem from "@/oxygen/variables/VariableRepeaterItem.vue";
import defensiveCopy from "@/util/defensive-copy";

@Component({
  components: {
    VariableRepeaterItem
  }
})
export default class OverrideVariablesInput extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  value!: Variable[];

  beforeCreate() {
    // @ts-ignore
    this.$options.components.Repeater =
      require("@/components/Reusable/CustomInputs/Repeater/Repeater.vue").default;
  }

  get variables() {
    return this.value || [];
  }

  get variablesToOverride() {
    return globalStore.variables;
  }

  get variableIds() {
    return this.variables.map(v => v.id);
  }

  get control() {
    return {
      options: {
        repeaterOptions: {
          buttonName: `Add Variable`,
          popupMode: true,
          noDisable: true,
          noDuplicate: true,
          disableFloatingAddButton: true,
          titleTemplate: this.repeaterVariableTemplate,
          defaultNewValue: {
            id: "{uuid}",
            type: "",
            label: "",
            cssVariableName: "",
            override: true
          }
        }
      }
    };
  }

  setVariable(variable: Variable, index: number) {
    const newVars = defensiveCopy(this.variables) || [];
    newVars[index] = variable;

    this.$emit("input", newVars);
  }

  repeaterVariableTemplate(row: Variable) {
    const foundVariable = this.variablesToOverride.find(v => v.id === row.id);
    const name = foundVariable
      ? foundVariable.cssVariableName
      : row.cssVariableName;

    if (!name) {
      return "(empty)";
    }

    const value = row?.value ? getVariablePreviewValue(row) : "(empty)";

    return `--${name}: ${value}`;
  }
}
